import { Breadcrumbs, Button, Card, CardActions, CardContent, FormControl, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import { Alert, AlertTitle } from '@material-ui/lab';
import axios from 'axios';
import { Form, Formik, FormikProps } from 'formik';
import { useSnackbar } from 'notistack';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { pdfjs } from 'react-pdf';
import { Link, useHistory } from 'react-router-dom';
import { AppInput } from '../components/atoms/inputs/AppInput';
import { LoadingButton } from '../components/atoms/inputs/LodingButton';
import { PdfViewer } from '../components/atoms/inputs/PdfViewer';
import { AppShell } from '../components/molecules/app-shell/AppShell';
import { useStore } from '../store';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;



const useStyles = makeStyles((theme) => ({
    controlPaper: {
        width: "100%",
        padding: "8px",
    },
    link: {
        display: 'flex',
        textDecoration: 'none',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    datePicker: {
        marginTop: 30,
        marginBottom: 30
    },
    relation: {
        marginBottom: 30
    },
    mL5: {
        marginLeft: 10,

    },

}))

type FormikForm = {
    year: string,
    part: string,
    file: any,
    fileName?: string,

    ppoNo: string,
}

type PDFUploadProps = {
}

type PPONumApiData = {
    'nameOfPensioner': string,
    'guardianName': string,
    'maritialStat': string,
    'relationWith': string,
    'address': string,
    'sex': string,
    'contactNo': string,
    'dateOfBirth': string,
    'dateOfCommencement': string,
    'panNum': string,
    'aadharNum': string,
    'ppoNo': string
}

type PPONumSubmitApiData = {
    pdfUrl: string,
    Success: string
}

export const PDFUpload: FunctionComponent<PDFUploadProps> = () => {
    const classes = useStyles()
    const store = useStore()
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();

    const getFiscalYear = (y: number) => `${y}-${(y + 1).toString().slice(-2)}`;

    const [profilePicture, setProfilePicture] = useState('');
    const [profilePictureBase64, setProfilePictureBase64] = useState('');
    const [profilePictureImageType, setProfilePictureImageType] = useState('');
    const [user, setUser] = useState<any>({
        ppoNo: "",
    });

    const [displayMessage, setDisplayMessage] = useState<any>(null);
    const [isEligible, setIsEligible] = useState(false);
    const [pdfPreview, setPdfPreview] = useState<any>(null);

    useEffect(() => {
        setUser({ ppoNo: store.auth.user?.id });
    }, []);

    useEffect(() => {
        checkEligibility()
    }, []);

    const checkEligibility = async () => {
        axios.get<any>(`${process.env.REACT_APP_NEW_API_ROOT}WBSEDCLERPPENSIONERCHECKPDFUPLOADELIGIBILITYWS/AllowAttestedPDFUpload`, {
            params: {
                queryParams: {
                    ppoNum: store.auth.user?.id,
                }
            },
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(
                ({ data: resp }) => {
                    console.log(resp, "resp eligibility");
                    if (resp && resp?.eligibleFlag == "Y") {
                        setIsEligible(true);
                        setPdfPreview(null);
                    }
                    else if (resp && resp?.eligibleFlag == "N" && !resp?.attestedPdfUrl) {
                        enqueueSnackbar("Please upload stamp size photograph and generate application form first", { variant: 'error' });
                        setDisplayMessage({ type: 'error', text: "Please upload stamp size photograph and generate application form first" });
                        setIsEligible(false);
                        setPdfPreview(null);
                    }
                    else if (resp && resp?.eligibleFlag == "N" && resp?.attestedPdfUrl) {
                        enqueueSnackbar("You have already uploaded the attested supporting document", { variant: 'error' });
                        setDisplayMessage({ type: 'error', text: "You have already uploaded the attested supporting document" });
                        setIsEligible(false);
                        setPdfPreview({
                            url: `${process.env.REACT_APP_NEW_API_ROOT}irj/go/km/docs${resp.attestedPdfUrl}?time=${new Date().getTime()}`,
                        });
                    }
                    else {
                        console.log("noooooooooooooooooo");

                        enqueueSnackbar("Something went wrong", { variant: 'error' });
                        setIsEligible(false);
                        setPdfPreview(null);
                    }
                }
            )
            .catch((e) => {
                console.log(e, "error");
                setIsEligible(false);
            })
    }

    const checkEligibilityAfterSubmit = async () => {
        axios.get<any>(`${process.env.REACT_APP_NEW_API_ROOT}WBSEDCLERPPENSIONERCHECKPDFUPLOADELIGIBILITYWS/AllowAttestedPDFUpload`, {
            params: {
                queryParams: {
                    ppoNum: store.auth.user?.id,
                }
            },
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(
                ({ data: resp }) => {
                    console.log(resp, "resp eligibility");
                    if (resp && resp?.eligibleFlag == "Y") {
                        setIsEligible(true);
                        setPdfPreview(null);
                    }
                    else if (resp && resp?.eligibleFlag == "N" && !resp?.attestedPdfUrl) {
                        setIsEligible(false);
                        setPdfPreview(null);
                    }
                    else if (resp && resp?.eligibleFlag == "N" && resp?.attestedPdfUrl) {
                        setIsEligible(false);
                        setPdfPreview(null);
                    }
                    else {
                        console.log("noooooooooooooooooo");

                        enqueueSnackbar("Something went wrong", { variant: 'error' });
                        setIsEligible(false);
                        setPdfPreview(null);
                    }
                }
            )
            .catch((e) => {
                console.log(e, "error");
                setIsEligible(false);
            })
    }

    const toBase64 = (file: any) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            return resolve(reader.result)
        };
        reader.onerror = error => reject(error);
    });


    return (
        <AppShell>
            <Grid container
                spacing={3}
                direction="column"
                justify="space-around"
                alignItems="stretch">
                <Formik
                    enableReinitialize
                    initialValues={{
                        year: getFiscalYear(new Date().getFullYear()),
                        part: "A",
                        file: pdfPreview,
                        fileName: 'UploadedAttestedApplicationForm.pdf',

                        ppoNo: user.ppoNo,
                    }}
                    validate={(values) => {
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue, setFieldTouched, setFieldError, resetForm }) => {
                        if (!values.ppoNo) {
                            enqueueSnackbar("Please enter PPO Number", { variant: 'error' });
                        }
                        else if (!profilePicture) {
                            enqueueSnackbar("Please upload a pdf", { variant: 'error' });
                        }
                        else {
                            setSubmitting(true)
                            resetForm();
                            console.log("SUBMIT+++++++++");


                            let inputs = {
                                "fppoNum": values.ppoNo,
                                "pdfAsString": profilePictureBase64
                            }

                            console.log(inputs);


                            fetch(`${process.env.REACT_APP_NEW_API_ROOT}WBSEDCLERPPENSIONERUPLOADATTESTEDPDFWS/UploadAttestedApplicationFormPdf`, { body: JSON.stringify(inputs), method: 'post' })
                                .then((response) => response.json())
                                .then((resp) => {
                                    console.log(resp);
                                    if (resp?.FLAG == "S") {
                                        enqueueSnackbar("Attested application form PDF successfully uploaded", { variant: 'success' });
                                        setProfilePicture('');
                                        setProfilePictureImageType('');
                                        setProfilePictureBase64('');
                                        checkEligibilityAfterSubmit();
                                    } else {
                                        enqueueSnackbar("Something went wrong. Please try again later", { variant: 'error' });
                                        setProfilePicture('');
                                        setProfilePictureImageType('');
                                        setProfilePictureBase64('');
                                    }
                                })
                                .catch((error) => {
                                    console.error(error);
                                    setProfilePicture('');
                                    setProfilePictureImageType('');
                                    setProfilePictureBase64('');
                                });
                        }
                    }}
                >
                    {
                        ({ values, isSubmitting, isValid, setFieldValue, setValues, handleChange, setSubmitting }: FormikProps<FormikForm>) => {
                            return (
                                <Form>
                                    <Grid
                                        item
                                        container
                                        spacing={3}
                                        direction="column"
                                        justify="space-around"
                                        alignItems="stretch"
                                    >
                                        <Grid item>
                                            <Card className={classes.controlPaper}>
                                                <CardContent>
                                                    <Grid container spacing={3} direction="column" justify="space-around"
                                                        alignItems="stretch">
                                                        <Grid item>
                                                            <Breadcrumbs>
                                                                <Link to="/" className={classes.link}>
                                                                    <Typography gutterBottom variant="h5" component="h2">
                                                                        <HomeIcon className={classes.icon} />Home</Typography>
                                                                </Link>
                                                                <Typography gutterBottom variant="h5" component="h2">Upload Attested Application Form PDF (স্বাক্ষরিত এবং সিলমোহরযুক্ত আবেদনপত্রের পিডিএফ অনলাইনে আপলোড করুন)</Typography>
                                                            </Breadcrumbs>
                                                        </Grid>

                                                        {
                                                            displayMessage &&
                                                            <Grid item>
                                                                <Alert severity={displayMessage.type}>
                                                                    <AlertTitle>
                                                                        {displayMessage.text}
                                                                    </AlertTitle>
                                                                </Alert>
                                                            </Grid>
                                                        }

                                                        <Grid item>
                                                            <FormControl variant="filled" fullWidth disabled={true}>
                                                                <AppInput
                                                                    inputProps={{ maxLength: 17 }}
                                                                    fullWidth={true}
                                                                    label={values.ppoNo.startsWith("800") ? "PPO Number (For existing pensioner)" : "FPPO Number (For existing Family pensioner)"}
                                                                    name="ppoNo"
                                                                    type="text"
                                                                    disabled={true}
                                                                />
                                                            </FormControl>
                                                        </Grid>

                                                        <Grid item>
                                                            <Button
                                                                variant="contained"
                                                                component="label"
                                                                size="large"
                                                                disabled={!isEligible || isSubmitting}
                                                            >
                                                                Upload PDF
                                                                <input
                                                                    type="file"
                                                                    hidden
                                                                    onChange={(e: (React.ChangeEvent<HTMLInputElement>) | any) => {
                                                                        console.log(e.target.files[0]);
                                                                        setFieldValue('fileName', `UploadedAttestedApplicationForm.pdf`)
                                                                        setFieldValue('file', e.target.files[0],
                                                                        )
                                                                        if (e.target.files[0] && e.target.files[0].size > 5242880) {
                                                                            enqueueSnackbar("The file must be less than or equal to 5 MB (megabytes)", { variant: 'error' });

                                                                            setProfilePicture('');
                                                                            setProfilePictureImageType('');
                                                                            setProfilePictureBase64('');
                                                                            return;
                                                                        }

                                                                        toBase64(e.target.files[0]).then((result: any) => {
                                                                            setProfilePicture(URL.createObjectURL(e.target?.files[0]));
                                                                            setProfilePictureImageType(e.target.files[0].name.substring(e.target.files[0].name.lastIndexOf(".") + 1, e.target.files[0].name.length));

                                                                            let remainder = result.substring(result.indexOf(",") + 1, result.length);
                                                                            setProfilePictureBase64(remainder);
                                                                        })
                                                                            .catch((e) => {
                                                                                setProfilePicture('');
                                                                                setProfilePictureImageType('');
                                                                                setProfilePictureBase64('');
                                                                                console.log(e, "prof error");
                                                                            })
                                                                            ;
                                                                    }}
                                                                    onClick={(event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
                                                                        const element = event.target as HTMLInputElement
                                                                        element.value = ''
                                                                    }}
                                                                    name="profilePicture"
                                                                    accept="application/pdf"
                                                                />
                                                            </Button>
                                                        </Grid>

                                                        <Grid item>
                                                            <Alert severity={'info'}>
                                                                <AlertTitle>
                                                                    Only .pdf accepted
                                                                </AlertTitle>
                                                            </Alert>
                                                        </Grid>
                                                        <Grid item>
                                                            <Alert severity={'info'}>
                                                                <AlertTitle>
                                                                    The file must be less than or equal to 5 MB (megabytes)
                                                                </AlertTitle>
                                                            </Alert>
                                                        </Grid>

                                                    </Grid>
                                                </CardContent>
                                                <CardActions>
                                                    <LoadingButton disabled={!isEligible} type="submit" size="large" color="primary" variant="contained" loading={isSubmitting}>
                                                        Submit
                                                    </LoadingButton>
                                                </CardActions>
                                            </Card>
                                        </Grid>
                                        {
                                            !!values.file && !!values.fileName &&
                                            < Grid item>
                                                <Card>
                                                    <CardContent>
                                                        <PdfViewer
                                                            downloadFileName={values.fileName}
                                                            file={values.file}
                                                            onDocumentLoadSuccess={() => { setSubmitting(false) }}
                                                            onDocumentLoadError={() => { setSubmitting(false) }}
                                                            error={
                                                                <>
                                                                    <Typography
                                                                        variant="h6"
                                                                        component="h6"
                                                                        style={{ textAlign: "center" }}
                                                                        color="secondary"
                                                                    >Something went wrong</Typography>
                                                                </>
                                                            }
                                                        />
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        }

                                        <Grid item className={classes.link}>
                                            <Button variant='contained' color='primary' type="button" size="large" onClick={() => { history.push('/track-pensioners-identity-card') }}>
                                                Know Pension Application Status
                                            </Button>
                                            <Link to="/" className={classes.mL5}>
                                                <Button variant='contained' color="primary" size="large">
                                                    Back (পিছনে)
                                                </Button>
                                            </Link>
                                        </Grid>


                                    </Grid>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Grid>
        </AppShell >
    )
}